import { Routes } from '@angular/router';
import { canActivateAuthRole } from './guards/auth.guard';
import { PERMISSIONS } from './shared/constants/permissions';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { NotFoundComponent } from './components/not-found/not-found.component';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'dashboard',
    component: DashboardComponent,
  },
  {
    path: 'sites',
    loadComponent: () =>
      import('./components/site-list/site-list.component').then(
        (m) => m.SiteListComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_READ_SITES },
  },
  {
    path: 'add-site',
    loadComponent: () =>
      import('./forms/add-site/add-site.component').then(
        (m) => m.AddSiteComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_CREATE_SITE },
  },
  {
    path: 'update-site/:siteId',
    loadComponent: () =>
      import('./forms/edit-site/edit-site.component').then(
        (m) => m.EditSiteComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_UPDATE_SITE },
  },
  {
    path: 'site-details/:siteId',
    loadComponent: () =>
      import('./components/site-details/site-details.component').then(
        (m) => m.SiteDetailsComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_READ_SITES },
  },
  {
    path: 'varieties',
    loadComponent: () =>
      import('./components/variety-list/variety-list.component').then(
        (m) => m.VarietyListComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_READ_VARIETIES },
  },
  {
    path: 'add-variety',
    loadComponent: () =>
      import('./forms/add-variety/add-variety.component').then(
        (m) => m.AddVarietyComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_CREATE_VARIETY },
  },
  {
    path: 'update-variety/:varietyId',
    loadComponent: () =>
      import('./forms/edit-variety/edit-variety.component').then(
        (m) => m.EditVarietyComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_UPDATE_VARIETY },
  },
  {
    path: 'variety-details/:varietyId',
    loadComponent: () =>
      import('./components/variety-details/variety-details.component').then(
        (m) => m.VarietyDetailsComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_READ_VARIETIES },
  },
  {
    path: 'waves',
    loadComponent: () =>
      import('./components/wave-list/wave-list.component').then(
        (m) => m.WaveListComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_READ_WAVES },
  },
  {
    path: 'add-wave',
    loadComponent: () =>
      import('./forms/add-wave/add-wave.component').then(
        (m) => m.AddWaveComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_CREATE_WAVE },
  },
  {
    path: 'update-wave/:waveId',
    loadComponent: () =>
      import('./forms/edit-wave/edit-wave.component').then(
        (m) => m.EditWaveComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_UPDATE_WAVE },
  },
  {
    path: 'wave-details/:waveId',
    loadComponent: () =>
      import('./components/wave-details/wave-details.component').then(
        (m) => m.WaveDetailsComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_READ_WAVES },
  },
  {
    path: 'productions',
    loadComponent: () =>
      import('./components/production-list/production-list.component').then(
        (m) => m.ProductionListComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_READ_PRODUCTIONS },
  },
  {
    path: 'add-production',
    loadComponent: () =>
      import('./forms/add-production/add-production.component').then(
        (m) => m.AddProductionComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_CREATE_PRODUCTION },
  },
  {
    path: 'update-production/:productionId',
    loadComponent: () =>
      import('./forms/edit-production/edit-production.component').then(
        (m) => m.EditProductionComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_UPDATE_PRODUCTION },
  },
  {
    path: 'production-details/:productionId',
    loadComponent: () =>
      import(
        './components/production-details/production-details.component'
      ).then((m) => m.ProductionDetailsComponent),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_READ_PRODUCTIONS },
  },
  {
    path: 'transfers',
    loadComponent: () =>
      import('./components/transfer-list/transfer-list.component').then(
        (m) => m.TransferListComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_READ_TRANSFERS },
  },
  {
    path: 'add-transfer',
    loadComponent: () =>
      import('./forms/add-transfer/add-transfer.component').then(
        (m) => m.AddTransferComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_CREATE_TRANSFER },
  },
  {
    path: 'update-transfer/:transferId',
    loadComponent: () =>
      import('./forms/edit-transfer/edit-transfer.component').then(
        (m) => m.EditTransferComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_UPDATE_TRANSFER },
  },
  {
    path: 'transfer-details/:transferId',
    loadComponent: () =>
      import('./components/transfer-details/transfer-details.component').then(
        (m) => m.TransferDetailsComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_READ_TRANSFERS },
  },
  {
    path: 'delintages',
    loadComponent: () =>
      import('./components/delintage-list/delintage-list.component').then(
        (m) => m.DelintageListComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_READ_DELINTAGES },
  },
  {
    path: 'add-delintage',
    loadComponent: () =>
      import('./forms/add-delintage/add-delintage.component').then(
        (m) => m.AddDelintageComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_CREATE_DELINTAGE },
  },
  {
    path: 'update-delintage/:delintageId',
    loadComponent: () =>
      import('./forms/edit-delintage/edit-delintage.component').then(
        (m) => m.EditDelintageComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_UPDATE_DELINTAGE },
  },
  {
    path: 'delintage-details/:delintageId',
    loadComponent: () =>
      import(
        './components/delintage-details/delintage-details.component'
      ).then((m) => m.DelintageDetailsComponent),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_READ_DELINTAGES },
  },
  {
    path: 'reports',
    loadComponent: () =>
      import('./components/report-list/report-list.component').then(
        (m) => m.ReportListComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_CREATE_REPORT },
  },
  {
    path: 'visual-report',
    loadComponent: () =>
      import('./components/visual-report/visual-report.component').then(
        (m) => m.VisualReportComponent
      ),
    canActivate: [canActivateAuthRole],
    data: { role: PERMISSIONS.SM_CAN_CREATE_REPORT_METRIC },
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import('./components/unauthorized/unauthorized.component').then(
        (m) => m.UnauthorizedComponent
      ),
  },

  { path: '**', redirectTo: 'not-found' },
];
